import { render, staticRenderFns } from "./CategoriesSection.vue?vue&type=template&id=88248e2a&scoped=true&"
import script from "./CategoriesSection.vue?vue&type=script&lang=js&"
export * from "./CategoriesSection.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesSection.vue?vue&type=style&index=0&id=88248e2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88248e2a",
  null
  
)

export default component.exports